export { default as NStatistic, statisticProps } from './src/Statistic';
